<div id="wrapper" class="panel-details search-component my-search">
    <div>
        <form [formGroup]="searchForm" (ngSubmit)="onSubmit()">
            <div class="row toggle-section">
                <div class="col-12">
                   <mat-button-toggle-group hideSingleSelectionIndicator="true" formControlName="searchCategory" (change)="onSearchCategoryChange($event.value)">
                        <mat-button-toggle value="Flight">Flight</mat-button-toggle>
                        <mat-button-toggle value="Name">Name</mat-button-toggle>
                        <mat-button-toggle value="Destination">Destination</mat-button-toggle>
                        <mat-button-toggle value="Tail">Tail</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
            </div>
            <div class="details-section">
                <div class="row">
                    <div class="input-frm">
                        <div>
                            <mat-label>Carrier:</mat-label>
                            <div>
                                <input class="searchBackground" matInput placeHolder="Carrier" formControlName="airlinePrefix" type="text" required>
                            </div>
                        </div>
                        <div class="wrapper">
                            <mat-label>Search Term:</mat-label>
                            <div>
                                <input class="searchBackground" matInput placeHolder="Search" formControlName="searchTerm" type="text" required>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="validationErrMsg">
                  <span style="color: orangered; font-weight: bold;">{{validationErrMsg}}</span>
                </div>

                <div class="row">
                    <div class="footer-section">
                        <button mat-raised-button type="submit" id="searchSubmit" class="btn btn-info">
                            Search <mat-icon>search</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div> <!-- End Search Container -->

    <div *ngIf="loading" style="width:95%; margin: auto;">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>

        <ng-container  *ngFor="let x of taskGroupSummaryList; let i = index">
            <div class="panel-container">
                <button mat-button (click)="panel.toggle()" class="toggle-button">
                    <mat-icon [ngClass]="{'is-open': panel.expanded}">navigate_next</mat-icon>
                </button>

                    <mat-expansion-panel [expanded]="x.taskName==expandedPanel"
                    (opened)="setExpandedpanel(x)" hideToggle disabled #panel class="expansion-panel" (closed)="expandedPanel = x.taskName === expandedPanel ? '0' : expandedPanel">
                    <mat-expansion-panel-header (click)="panel.toggle()">
                        <mat-panel-description>
                            <div class="header">
                                <div>{{x.displayName}}</div>
                                <div>{{x.parkingPosition}}</div>
                                <div>{{x.tailNumber}}</div>
                                <div class="flight-status">
                                    <span>{{x.typeName === 'InboundFlight' ? x.origin : x.destination}}</span>
                                    <mat-icon [ngClass]="{'downwards':x.typeName ==='InboundFlight', 'upwards': x.typeName ==='OutboundFlight'}">flight</mat-icon>
                                    <span class="outOffOnInText" *ngIf="x.typeName ==='InboundFlight'">{{x.actualOnTime && !x.actualInTime ? '(ON)' : ''}} {{x.actualInTime ? '(IN)' : ''}}</span>
                                    <span class="outOffOnInText" *ngIf="x.typeName ==='OutboundFlight'">{{x.actualOutTime && !x.actualOffTime ? '(OUT)' : ''}} {{x.actualOffTime ? '(OFF)' : ''}}</span>
                                </div>
                            </div>
                            <div class="customsIconDiv">
                                <div *ngIf="checkCustoms(x?.origin)">C</div>
                            </div>
                            <div class="time-status due"
                            [ngClass]="{'due': time[0] ==='EARLY', 'overdue': time[0] ==='LATE', 'actual-on-time': x.actualOnTime !== null && x.actualInTime === null}" *ngIf="getdueTime(x.arrivalTime); let time">
                                <div class="time">{{time[0] === 'LATE' ? '-' : ''}}{{time[1]}}</div>
                                <div class="unit">{{time[2]}}</div>
                            </div>
                        </mat-panel-description>
                    </mat-expansion-panel-header>



                    <form class="content-area" [formGroup]="driverTasksForm">
                        <!-- Task Detail OOOI Times Section -->
                        <div class="time-section">
                            <div>
                              <div class="time-header">CPL</div>
                              <div>
                                {{ x.actualEnd !== null && x.actualEnd !== 'Invalid date' && x.actualEnd !== '' ? (x.actualEnd | momentFormat : 'H:mm') : '--' }}
                              </div>
                            </div>
                            <div>
                              <div class="time-header">{{x.typeName === 'InboundFlight' ? 'STA' : 'STD'}}</div>
                              <div>{{x.typeName === 'InboundFlight' ? x.scheduledArrivalTime || '--' : x.scheduledDepartureTime || '--'}}</div>
                            </div>
                            <div>
                              <div class="time-header">{{x.typeName === 'InboundFlight' ? 'ETA' : 'ETD'}}</div>
                              <div>{{x.typeName === 'InboundFlight' ? x.estimatedArrivalTime || '--' : x.estimatedDepartureTime || x.scheduledDepartureTime || '--'}}</div>
                            </div>
                            <div>
                              <div class="time-header">{{x.typeName === 'InboundFlight' ? 'ON' : 'OUT'}}</div>
                              <div>{{x.typeName === 'InboundFlight' ? x.actualOnTime || '--' : x.actualOutTime || '--'}}</div>
                            </div>
                            <div>
                              <div class="time-header">{{x.typeName === 'InboundFlight' ? 'IN' : 'OFF'}}</div>
                              <div>{{x.typeName === 'InboundFlight' ? x.actualInTime || '--' : x.actualOffTime || '--'}}</div>
                            </div>
                          </div>
                        <div class="time-section">
                          <h3>
                            {{ (x.assignTo && x.assignTo !== "") ? 'Driver: ' + getDriverName(x.assignTo) : 'Unassigned' }}
                          </h3>
                        </div>
                        <div class="add-item-section">
                            <div *ngFor="let person of x.passengers">
                                <div class="item-rows" flex>
                                  <div class="item cpt" >
                                    <div class="first-label-column">
                                      <mat-label>{{person.role}}</mat-label>
                                    </div>
                                    <div class="name-column">
                                      <mat-label>{{person | passengerNameFormat}}</mat-label>
                                    </div>
                                    <div class="toggle-column">
                                      <mat-slide-toggle *appHasRole="['cvv_coordinator','cvv_driver']"
                                        color="primary" (change)="onPassngerCheckedIn($event)"
                                        [formControl]="getPassengerFormControl(x.taskName, person.id, x.status)">
                                      </mat-slide-toggle>
                                    </div>
                                    <div class="type-icon-column">
                                      <mat-icon class="icon-user-switch" svgIcon="icon-user"  aria-hidden="true"></mat-icon>
                                    </div>
                                    <div class="warning-icon-column">
                                      <fa-icon class="alertDarkMode" *ngIf="!person.checkedIn" [icon]="warningIcon" style="color: orange;"></fa-icon>
                                    </div>
                                    <div class="trash-button-column">
                                      <button mat-raised-button [ngStyle]="{'float':'right'}" disabled >
                                        <mat-icon>delete</mat-icon>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                            <div>
                                <div *ngFor="let detail of x.addOnDetails">
                                  <div class="item-rows" flex>
                                    <div class="item cpt">
                                      <div class="first-label-column">
                                        <mat-label>{{detail.type}}</mat-label>
                                      </div>
                                      <div class="name-column">
                                        <mat-label>{{detail.name}}</mat-label>
                                      </div>
                                      <div class="toggle-column">
                                        <mat-slide-toggle *appHasRole="['cvv_coordinator','cvv_driver']"
                                        color="primary"
                                          [formControl]="getDetailsFormControl(x.taskName, x.status, detail.id)">
                                        </mat-slide-toggle>
                                      </div>
                                      <div class="type-icon-column">
                                        <mat-icon *ngIf="detail.type === 'Passenger' || detail.type === 'JS' || detail.type === 'FO' || detail.type === 'CPT'" class="icon-user-switch" svgIcon="icon-user"  aria-hidden="true"></mat-icon>
                                        <mat-icon *ngIf="detail.type === 'Other'" class="icon-tasks-switch" svgIcon="icon-tasks"  aria-hidden="true"></mat-icon>
                                        <mat-icon *ngIf="detail.type === 'Catering'" class="icon-cutlery-switch" svgIcon="icon-catering"  aria-hidden="true"></mat-icon>
                                        <mat-icon *ngIf="detail.type === 'Paperwork' || detail.type === 'Customs'" class="icon-file-switch" svgIcon="icon-file"  aria-hidden="true"></mat-icon>
                                      </div>
                                      <div class="warning-icon-column">
                                        &nbsp;
                                      </div>
                                      <div class="trash-button-column">
                                        <button *appHasRole="['cvv_coordinator','cvv_driver']" mat-raised-button [ngStyle]="{'float':'right'}" (click)="onRmoveTaskDetails(x.taskName, detail.id)"><mat-icon>delete</mat-icon></button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div  class="item-rows dynamic-addon-row" flex>
                                <div *ngIf="showAdd" class="item" [ngStyle]="{'display': 'flex'}">
                                  <div>
                                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                      <mat-select placeholder="Select"  #rowType >
                                        <mat-option *ngFor="let type of addItemTypes" [value]="type.value">{{type.name}}</mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                      <input matInput #rowValue />
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <button *appHasRole="['cvv_coordinator','cvv_driver']" type="button" [disabled]="rowType.value === undefined" mat-raised-button color="primary" (click)="populateAndAddTaskDetails(x.taskName, rowType.value, rowValue.value, $event)">Add +</button>
                                  </div>
                                  <div>
                                    <button *appHasRole="['cvv_coordinator','cvv_driver']" mat-raised-button [ngStyle]="{'float':'right'}" (click)="toggleAddItem(false)"><mat-icon>delete</mat-icon></button>
                                  </div>
                                </div>
                                <button *appHasRole="['cvv_coordinator','cvv_driver']" mat-icon-button aria-label="Add Pickup Details" class="add-pickup-button"  (click)="toggleAddItem(true)">
                                  <mat-icon>add_circle</mat-icon>
                                </button>
                              </div>
                        </div>

                        <!-- Notes Section -->
                        <div class="notes-section">
                          <div>
                            <mat-label>Coord. Notes:</mat-label>
                            <textarea matInput class="form-control" rows="4" formControlName="cordNotes" readonly></textarea>
                          </div>
                          <div>
                            <mat-label>Driver Notes:</mat-label>
                            <textarea matInput class="form-control" rows="4" formControlName="driverNotes"></textarea>
                          </div>
                        </div>
                        <div class="assign-task" *appHasRole="['cvv_coordinator','cvv_driver']">
                          <!-- pickup buttons -->
                          <div *ngIf="showPickUpButtons(x?.status)" class="form-button-rows-wrap">
		                            <button type="button" class="pickup-all-button" mat-raised-button
                                  (click)="pickup(x, PickUpDropOffType.PICKUP_ALL)" [disabled]="currentTaskToProcess === x?.taskName">
                              <span>{{currentTaskToProcess === x?.taskName ? 'Processing... ' : 'Pickup All '}}</span>
                              <mat-icon class="material-icons-outlined" svgIcon="icon-user"></mat-icon>
                            </button>

                            <button type="button" class="pickup-selected-button" mat-raised-button
                              (click)="pickup(x, PickUpDropOffType.PICKUP_SELECTED)"
                              [disabled]="driverTasksForm.pristine || !canPickupSelected(x) || currentTaskToProcess === x?.taskName">
                              <span>{{currentTaskToProcess === x?.taskName ? 'Processing... ' : 'Pickup Selected '}}</span>
                              <mat-icon class="material-icons-outlined" svgIcon="icon-user"></mat-icon>
                            </button>
                          </div>
                        </div>

                        <div *appHasRole="['cvv_coordinator','cvv_driver']" class="assign-task">
                            <button *ngIf="!x.assignTo" type="button" mat-raised-button color="primary" (click)="assignTask(x.taskName)">
                               <span>Assign Task</span>
                               <mat-icon>playlist_add</mat-icon>
                             </button>
                          </div>
                    </form>

                </mat-expansion-panel>
            </div>
        </ng-container>
</div>